<template>
  <div>
    <h2>{{ $t('title.mobile-groups') }}</h2>

    <base-list
    model="mobile-groups"
    :columns="['name', 'description']"
    sModel="mobile-group"
    />
  </div>


</template>

<script>
import BaseList from 'components/BaseList'

export default {
  name: 'mobile-group-list',
  components: { BaseList }
}
</script>


// WEBPACK FOOTER //
// MobileGroupList.vue?80448a9a